// zh.js
export default {
  // 可以以页面为单位来写，比如首页的内容，写在index字段，个人中心写在center，公共部分写在common部分
  lang: {
    title: 'uView UI',
    intro: '多平台快速开发的UI框架'
  },
  loain: {
    _Inscreverse: 'Registro',
    _AcessoDeMembro: 'Login'
  },
  _buome: {
    _Retornar: 'Retornar',
    _Salvar: 'Salvar'
  },

  _placeholder: {
    _Introduza: 'Introduza a ID do WeChat',
    _IntroduzaMessage:
      'ID WeChat deve começar com letra ou sublinhado e ter de 6 a 20 letras, números, sublinhados e/ou hífens.',
    _WhatsApp: 'Insira o ID do WhatsApp',
    _WhatsAppMessage: 'Introduza 6-40 números',
    _Facebook: 'Insira o ID do Facebook',
    _FacebookMessage:
      'Por favor, insira 3-50 bits de inglês/números/caracteres',
    _telegram: 'Insira o ID do telegram',
    _telegramMessage: 'Introduza 5-40 letras/números/sublinhados',
    _Selecione:
      'Selecione a data de nascimento (depois de definida, não pode ser modificada)',
    _PorFavorSenha: 'Por favor, insira a nova senha',
    _Outros: 'Outros Métodos de Verificação',
    _ConfirmarNovoSenha: 'Confirmar Novo Senha',
    _TodasPlataformas: 'Todas as Plataformas',
    _DetalhesdaSubcategoria: 'Detalhes da Subcategoria',
    _Inserirnomedeusurio: 'Inserir nome de usuário',
    _Introduzapalavrapasse: 'Introduza a palavra-passe'
  },

  menGMen: {
    _NomedeUsuário: 'Nome de Usuário',
    _Desvincular: 'Desvincular',
    _deTelefone: 'Nº de Telefone',
    _EndereMail: 'Endereço de e-mail',
    _GoogleAuthenticator: 'Google Authenticator',
    _SenhadeLogin: 'Senha de Login',
    _SenhadeSaque: 'Senha de Saque',
    _FoiDefinido: 'Foi Definido',
    _NConfigurado: 'Não Configurado',
    _Perguntade: 'Pergunta de Segurança',
    _Deletartudo: 'Deletar tudo',
    _Apostas: 'Apostas',
    _Valor: 'Valor',
    _Ganhos: 'Ganhos',
    _Semdadosdispo: 'Sem dados disponíveis',
    _Informapromo: 'Informações da promoção',
    _Subordinados: 'Subordinados diretos',
    _Convite_me: 'Código de Convite',
    _Subordinadoslidos: 'Subordinados válidos',
    _pessoas: 'pessoas',
    _Detalhes: 'Detalhes',
    _queCumprir:
      'que é um número válido promocional?(Cumprir todos os requisitos indicados abaixo)',
    _subordinadoMens: 'Depósitos acumulados do subordinado',
    _ouMais: 'ou mais',
    _ApostasSubordinado: 'Apostas acumuladas do subordinado'
  },
  _Nenhumjogodisponvel: 'Nenhum jogo disponível',
  _Misto: 'Misto',

  _home: {
    _Popularjogos: ' jogos',
    _Aexibir: ' A exibir ',
    _jogosentre: 'jogos entre',
    _Carregarmais: 'Carregar mais',
    _Eventos: 'Eventos',
    _Missão: 'Missão',
    _Rebate: 'Rebate',
    _Pendente: 'Pendente',
    _VIP: 'VIP',
    _Sorteio: 'Sorteio',
    _Checkin: 'Check-in',
    _Convidar: 'Agente',
    _Compartilhar: 'Compartilhar',
    _FundodePrevidência: 'Fundo de Previdência',
    _Surpresa: 'Surpresa',
    _Slots: 'Slots',
    _Pescaria: 'Pescaria',
    _Demo: 'Demo',
    _Todos: 'Todos',
    _Mais: 'Mais',
    _Suporteonline: 'Suporte online',
    _CentraldeAjuda: 'Central de Ajuda',
    _BônusdeSugestão: 'Bônus de Sugestão',
    _Segurança: 'Segurança',
    _Cassino: 'Cassino',
    _Jogos: 'Jogos',
    _Suporte: 'Suporte',
    _LicenseCompliance: 'Conformidade de licença',
    _Contatenos: 'Contate-Nos',
    _CanalOficial: 'Canal Oficial',
    _tis: 'O jogo está em manutenção',
    _balanceLess1: 'Seu saldo é menor que R$',
    _balanceLess2: ', Por favor,\r\nfaça um depósito para jogar',
    _rechargeLess1:
      'Sua conta não está ativada. Por favor,\r\nfaça um depósito de qualquer valor para\r\nativar sua conta e começar a jogar.',
    _rechargeLess2: 'Seu depósito é menor que R$',
    _rechargeLess3: ', Por favor,\r\nfaça um depósito para jogar',
    _Válidos: 'Válidos',
    _Válido: 'Válido',
    _Inválido: 'Inválido',
    _Taxade: 'Taxa de',
    _ReceberTudo: 'Receber Tudo',
    _Podeserresgatadohoje: 'Pode ser resgatado hoje',
    _CASSINO: 'CASSINO',
    _entertainment:
      'is an online entertainment website that offers its users a unique sports betting experience. This website is operated by',
    _NovaWave: 'NovaWave Technology N.V.',
    _Caribbeaundern:
      'a company registered in Curaçao, under number 162293, with registered office in Schottegatweg Oost 10, Unit 1-9, Bon Bini Business Center, Willemstad, Curaçao, Dutch Caribbean, an entity duly authorized and licensed by the Government of Curaçao.',
    _accessingBy:
      'By accessing, continuing to use, or browsing this website you agree that we may use certain browser cookies to improve your experience whilst using our site. We only use cookies to enhance your experience, and this does not interfere with your privacy',
    _Distnciaw: 'Distância',
    _Convideumpacote: 'Convide um amigo para abrir um pacote vermelho de bônus',
    _Recebido: 'Recebido',
    _Montantefixo: 'Montante fixo',
    _jogador: 'Jogador',
    _payout: 'Pagar',
    _Mais: 'Mais',
    _Saques: 'Saques',
    _Blockchain: 'Blockchain',
    _DownloadAPPMoreDiscounts: 'Baixe o APP para participar de mais descontos!',
    _BaixarAgora: 'Baixar Agora',
    _Pesquisar: 'Pesquisar',
    _BaixeeuseoAPP: 'Baixe e use o APP',
    _BaixeoAPP: 'Baixe o APP',
    _aproveitarmaisdescontos: 'aproveitar mais descontos'
  },

  _VIP: {
    _Lembrete: 'Lembrete',
    _LembreteConter:
      'Para avançar para o próximo nível, é necessário fazer apostas adicionais além do total acumulado de apostas válidas. Por exemplo: se o requisito de apostas válidas para avançar para o VIP1 é de 1000, e o requisito para avançar para o VIP2 é de 2000, então o membro precisa acumular um total de 1000 + 2000 = 3000 apostas válidas para avançar para o VIP2, e assim por diante.',
    _LembreteConterDeposit:
      'Para ascender al siguiente nivel, los miembros deben alcanzar un depósito acumulado. Por ejemplo, si el requisito de depósito para ascender a VIP1 es de 30 y el requisito de depósito para ascender a VIP2 es de 300, entonces el depósito acumulado de 300 de un miembro puede ascender a VIP2, y así sucesivamente.',
    _NívelAtual: 'Nível Atual',
    _Restantes: 'Restantes',
    _Apostemais: 'Aposte mais',
    _DepositMore: 'Depósito mais',
    _ResgatarTudo: 'Resgatar Tudo',
    _Histórico: 'Histórico',
    _ListadeníveisVIP: 'Lista de níveis VIP',
    _InstruçõessobreregrasVIP: 'Instruções sobre regras VIP',
    _Nível: 'Nível',
    _Apostaparapromoção: 'Aposta para promoção',
    _DepositPromotion: 'Depósito para promoção',
    _BônusDeAumentoDe: 'Bônus De Aumento De ',
    _Bônus: 'Bônus',
    _Ovalortotaldaretiradadiária: 'Número de retiradas por dia',
    _Olimitesuperiordaretiradadiária: 'O limite superior da retirada diária',
    _Taxasdeisençãodiáriacaneta: 'Taxas de isenção diária caneta',
    _NumberOfWithdrawals: 'Número de retiradas',
    _WithdrawalLimit: 'Limite de retirada',
    _PenExemptionFees: 'Taxas de isenção de caneta',
    _Totaldedepósitos: 'Total de depósitos',
    _FundodePrevidência: 'Fundo de Previdência',
    _Depósito: 'Depósito',
    _Retira: 'Retira',
    _Nãosertapado: 'Não ser tapado',
    _BônusMáximoNãosertapado: 'Bônus Máximo',
    _LimiteMáximoNãosertapado: 'Limite Máximo',
    _acumulaçãototal0: 'acumulação total',
    _Horário: 'Horário',
    _Taxadebônus: 'Taxa de bônus',
    _Taxadebônus: 'Taxa de bônus',
    _Númerodeapostas: 'Número de apostas',
    _Novosrequerimentosparaaposta: 'Novos requerimentos para aposta',
    _Vocêprecisaapostar: 'Você precisa apostar',
    _presenteMeLOfgn: 'Método de presente',
    _recarregar:
      'Cada vez que você recarregar , você receberá um bônus no valor da recarga 100%. O bônus é depositado na conta do fundo de previdência. Quanto mais você recarregar, mais recompensas receberá.',
    _Condies: 'Condições',
    _Cadaprevid:
      'Cada vez que recarregar, um novo fundo de previdência será acumulado, então você deve completar apostas eficazes 35 vezes o valor principal da recarga a cada vez antes de poder retirar o fundo de previdência; se o fundo de previdência não for dado ou tiver sido limitado, você precisa completar apostas eficazes 5 vezes da recarga.',
    _BnusMximo: 'Bônus Máximo',
    _gratuitos:
      'Durante o ciclo de atividade,Número de presentes gratuitos,Não há limite para o montante acumulado no CPF.',
    _Redefinirciclo: 'Redefinir ciclo',
    _retiradoMense_mes:
      'O período de validade do fundo de previdência é 1Por mês，Não retirado 31 dias após o final do ciclo，A recompensa do fundo de previdência será inválida e o fundo de previdência só poderá ser recebido uma vez por ciclo.',
    _Auditoriamltipla: 'Auditoria múltipla',
    _fundoRetirado:
      'O bônus do fundo de reserva retirado requer 15 vezes de apostas efetivas antes de solicitar o saque, com apostas limitadas a Plataforma de jogo ilimitada.',
    _Recebarestries: 'Receba restrições',
    _apenasAndroid:
      'Disponível apenas para resgate manual no PC、H5、Android-APP、iOS-APP.',
    _Violadasregras: 'Violação das regras',
    _meSomente:
      'Somente o proprietário da conta pode realizar operações humanas normais. É proibido alugar, utilizar plug-ins, robôs, jogar com contas diferentes, escovação mútua, arbitragem, interfaces, protocolos, exploração de brechas, controle de grupo ou outros meios técnicos. Caso contrário, a participação será cancelada ou as recompensas serão deduzidas, congeladas ou mesmo colocadas na lista negra.',
    _Aexplicainal: 'A explicação final',
    _Paraevitar:
      'Para evitar diferenças na compreensão do texto, a plataforma reserva-se o direito de interpretação final deste evento.',
    _des_1:
      'Padrão de promoção: atenda aos requisitos da promoção VIP (ou seja, a recarga ou apostas eficazes podem atender às condições), você pode avançar para o nível VIP correspondente e obter o bônus de promoção correspondente.O bônus pode ser recebido de tempos em tempos;',
    _des_2:
      'Salário diário: Se a recarga diária e as apostas válidas atenderem aos requisitos salariais diários do nível atual, você poderá obter o bônus salarial diário correspondente. Se você avançar para vários níveis consecutivos, só poderá obter o bônus salarial diário do atual nível.O bônus pode ser recebido de tempos em tempos;',
    _des_3:
      'Salário Semanal: Se a recarga semanal e as apostas válidas atenderem ao nível atual de requisitos salariais semanais, você poderá obter o bônus salarial semanal correspondente. Se você avançar para vários níveis consecutivos, poderá obter apenas o nível atual de bônus salarial semanal.O bônus pode ser recebido de tempos em tempos;',
    _des_4:
      'Lulu mensal: recarga mensal e apostas efetivas para atender ao nível atual do Lulu mensal, e você pode obter o bônus de prêmio mensal correspondente.O bônus pode ser recebido de tempos em tempos;',
    _des_5:
      'Tempo de Expiração da Recompensa: O bônus recebido fica disponível por %d dias. Se não for resgatado ativamente durante esse período, ele será automaticamente creditado na conta. Por exemplo: se uma recompensa for obtida em 1º de janeiro e retida por %d dias, será automaticamente creditada na conta em %d de janeiro às 00:00:00.',
    _des_6:
      'Instruções para auditoria: o bônus VIP oferecido pode ser levantado apenas após o cumprimento do requisito de rollover 1x (ou seja, auditoria, apostas ou apostas válidas), independentemente da plataforma em que joga;',
    _des_7:
      'Declarações: Esta função está limitada às operações normais dos titulares de contas. É proibido alugar contas, efetuar apostas sem risco (apostas com contas diferentes, swiping mútuo e swiping de odds baixas), arbitragem viciosa, utilizar plug-ins, robôs, exploração de acordos, lacunas, interfaces, controlo de grupo ou outros meios técnicos de participação; caso contrário, uma vez provado, a plataforma tem o direito de proibir os membros de iniciar sessão, suspender a utilização do nosso website, e confiscar o bônus e os ganhos indevidos, sem qualquer aviso especial;',
    _des_8:
      'Instruções: Ao reclamar o bônus VIP, considera-se que os membros aceitam e cumprem as regras correspondentes. A fim de evitar diferenças na compreensão do texto, a plataforma reserva o direito final de interpretar esta atividade. '
  },

  yuebao: {
    _Apostado: 'Apostado',
    _Introduaosganhos: 'Introdução aos ganhos',
    _mens_depositado:
      'O valor depositado no tesouro de juros deve cumprir um ciclo completo para gerar juros. Se for sacado antes, o ciclo não contará para os lucros. Por exemplo, se o período atual de liquidação for de 1 horas, o valor transferido em 2023-01-01 00:00:01 gerará o primeiro ciclo de juros em 2023-01-01 01:00:01;',
    _CiclodeLiquida: 'Ciclo de Liquidação',
    _horasatualde: 'O período atual de liquidação de juros é de 1 horas;',
    _Taxadejurosanual: 'Taxa de juros anual',
    _menNemsn: ' A taxa de juros anual atual é100%;',
    _Frmuladelculo: 'Fórmula de cálculo',
    _LucroDos:
      'Lucro dos juros = valor do depósito * taxa de juros anual / período de liquidação;',
    _Exemplo: 'Exemplo',
    _Umem_anual:
      'Um depósito de 10.000 em 01/01/2023 às 00:00:01, com a taxa de juros anual de 100%, e o período de liquidação de 1 horas, tem como seu primeiro rendimento de juros obtido 2023-01-01 01:00:01. O cálculo é o seguinte',
    _PrimeiroMensDejuros:
      'Primeiro rendimento de juros = 10.000*100%/365 dias/24 horas*1 horas = 1.141552',
    _Limiardeentrada: 'Limiar de entrada',
    _Limitedejuros: 'Limite de juros',
    _ltiplodeauditoria: 'Múltiplo de auditoria',
    _Declaradoevento: 'Declaração do evento',
    _Explica: 'Explicação',
    _valorCadaIgual:
      'O valor de cada transferência deve ser maior ou igual a 50 (ou seja, ≥ 50), sem limite superior no valor da transferência. Quanto mais você transfere, maior o lucro;',
    _taxaDeIurosAtual:
      'Não há limite para a taxa de juros atual. Lembre-se de cobrar sua renda regularmente ou com frequência para evitar perder mais renda;',
    _Depositado: 'Depositado',
    _Tempodereivindica: 'Tempo de reivindicação',
    _resgatarPode:
      'Pode resgatar no próximo dia, o que significa que os juros gerados no mesmo dia podem ser reivindicados após 00:00 do próximo dia.',
    _ensbeConemauditoria:
      'O múltiplo de auditoria atual é 30 vezes (requisito de volume de apostas). Isso significa que os juros recebidos devem ser apostados antes do saque. Aposta.Plataforma válida ilimitadaApenas os juros recebidos requerem auditoria, enquanto o valor principal transferido para dentro ou para fora não requer auditoria;',
    _Estalimitada:
      'Esta função é limitada à conta. Tenho uma apostas normal de jogo e é proibido alugar uma conta, sem apostas de risco (para jogos de azar, emparelhamento, baixa compensação, escovar água), Arbitragem maliciosa, usando processos de plug -in, robôs, robôs utilizam acordos, vulnerabilidades, interfaces,O controle de grupo ou outros meios técnicos são proibidos. Uma vez verificado, a plataforma reserva o direito de encerrar os logins dos membros, suspender o uso do site pelos membros e confiscar bônus e lucros impróprios sem aviso prévio;',
    _Ciclodeassentamento1horas: 'Ciclo de assentamento\n1 horas',
    _Coleçãocumulativa: 'Coleção cumulativa',
    _QuandoNmmembro:
      'Quando um membro recebe a recompensa Yibao, a plataforma presumirá que o membro concorda e cumpre as condições correspondentes e outros regulamentos relevantes. Para evitar ambiguidade na compreensão do texto, a plataforma reserva-se a final. direito de interpretar este evento;',
    _MáximodejurosIlimitado: 'Máximo de juros\nIlimitado',
    _TaxadeJurosAnual100: 'Taxa de Juros Anual 100.00%',
    _Depósito: 'Depósito',
    _Transferir: 'Transferir',
    _Receber: 'Receber',
    _Horas: 'Horas',
    _Tipos: 'Tipos',
    _Quantia: 'Quantia',
    _RendaAcumulada0: 'Renda Acumulada',
    actiVCo: [
      {
        text: 'Hoje',
        value: 0
      },
      {
        text: 'Ontem',
        value: 1
      },
      {
        text: 'Últimos 7 Dias',
        value: 2
      },
      {
        text: 'Últimos 15 Dias',
        value: 3
      },
      {
        text: 'Últimos 30 Dias',
        value: 4
      }
    ],
    actiVCo1: [
      {
        text: 'Tudo',
        value: 0
      },
      {
        text: 'Depósito',
        value: 1
      },
      {
        text: 'Transferir',
        value: 2
      },
      {
        text: 'Receber Saldo',
        value: 3
      }
    ]
  },
  description: 'Sem Registros',

  toolbar: [
    {
      title: 'Inicio'
    },
    {
      title: 'Promoção'
    },
    {
      title: 'Agente'
    },
    {
      title: 'Suporte'
    },
    {
      title: 'Perfil'
    }
  ],
  toolbarConter: {
    _Inicio: 'Começar',
    _Inicio2: 'Inicio',
    _Promoção: 'Promoção',
    _Agente: 'Agente',
    _Suporte: 'Suporte',
    _Perfil: 'Perfil',
    _Depósito: 'Depósito',
    _Saque: 'Saque',
    _Login: 'Login',
    _Registro: 'Registro'
  },

  popup: {
    nav: [
      {
        title: 'Popular'
      },
      {
        title: 'Slots'
      },
      {
        title: 'Pescaria'
      },
      {
        title: 'Demo'
      },
      {
        title: 'Recente'
      },
      {
        title: 'Favoritos'
      }
    ],
    nav_31: [
      {
        title: 'Popular'
      },
      {
        title: 'Slots'
      },
      {
        title: 'Blockchain'
      },
      {
        title: 'Pescaria'
      },
      {
        title: 'Demo'
      },
      {
        title: 'Recente'
      },
      {
        title: 'Favorites'
      }
    ],
    _Blockchain: 'Blockchain',
    _parareceber: 'para receber',
    _TaxadeRebate: 'Taxa de Rebate',
    _Recompensas: 'Recompensas',
    _Slots: 'Slots',
    _Demo: 'Demo',
    _Recente: 'Recente',
    _Popular: 'Popular',
    _Pescaria: 'Pescaria',
    _Blockchain: 'Blockchain',
    _Favoritos: 'Favoritos',
    _Apostas: 'Apostas',
    _Agente: 'Agente',
    _Promoção: 'Promoção',
    _Eventos: 'Eventos',
    _Histórico: 'Histórico',
    _FundodePrevidência: 'Fundo de  Previdência',
    _Pendente: 'Pendente',
    _Juros: 'Juros',
    _VIP: 'VIP',
    _Português: 'Português',
    _BaixarApp: 'Baixar App',
    _Suporte: 'Suporte',
    _FAQ: 'FAQ',
    _Sobre: 'Sobre',
    _Aexibir: 'A exibir',
    _jogosEntre: 'jogos entre',
    _PopularIogos: 'Popular jogos',
    _Carregarmais: 'Carregar mais',
    _BônusDeAumentoDeNível: 'Bônus De Aumento De Nível',
    _BônusSemanal: 'Bônus Semanal',
    _BônusMensal: 'Bônus Mensal',
    _PrivilégioVIP: 'Privilégio VIP',
    _Detalhesdoregistro: 'Detalhes do registro',
    _Regrasdejuros: 'Regras de juros',
    _Totalderegistros: 'Total de registros',
    _RequisitosDeapostas: 'Requisitos de apostas',
    _Regras: 'Regras'
  },

  share: {
    _LinkdeConvite: 'Link de Convite',
    _MeusDados: 'Meus Dados',
    _TodososDados: 'Todos os Dados',
    _Desempenho: 'Desempenho',
    _Comissãopor: 'Comissão por',
    _Comissão: 'Comissão',
    _DadosdoSubordinado: 'Dados do Subordinado',
    _ApostasdosSubordinados: 'Apostas dos Subordinados',
    _TaxadeComissão: 'Taxa de Comissão',
    _CadastrarSubordinados: 'Cadastrar Subordinados'
  },
  notice: {
    _Suporte: 'Suporte',
    _Notícia: 'Notícia',
    _Notificação: 'Notificação',
    _PainelRolante: 'Painel Rolante',
    _BônusdeSugestão: 'Bônus de Sugestão',
    _TelegramSuporte: 'Telegram Suporte',
    _FacebookSuporte: 'Facebook Suporte',
    _WhatsAppSuporte: 'WhatsApp Suporte',
    _FAQ: 'FAQ',
    _PerguntasFreqüentes: 'Perguntas Freqüentes',
    _Apoioonline: 'Apoio online',
    _Contactaragora: 'Contactar agora',
    _Conversecomoserv:
      'Converse com o serviço profissional de apoio ao cliente online para resolver os seus problemas',
    _SemMensagem: 'Sem Mensagem',
    text1: 'Atendimento ao cliente online 24',
    text2:
      'Serviço ao cliente disponível para ajudar a solucionar problemas e responder a dúvidas apresentadas.',
    text3: 'Contato',
    text4: 'Canal Oficial',
    text5: 'Official Channel ®',
    text6: 'Atendimento ao cliente Telegram',
    text7: 'Atendimento ao cliente Whatsapp'
  },
  Recharge: {
    _PaymentMethod: 'Método de Pagamento',
    _Firstdeposit: 'Primeiro depósito',
    _withBonus: 'Com Bônus'
  },
  withdraw: {
    _Solicitarsaque: 'Solicitar saque',
    _TarefasdeApostas: 'Tarefas de Apostas',
    _Contapararecebimento: 'Conta para recebimento',
    _RegistrodeSaques: 'Registro de Saques',
    _Paraasegurança:
      'Para a segurança da sua conta, introduza a palavra-passe de levantamento',
    _EsqueceuaSenha: 'Esqueceu a Senha?',
    _Próximo: 'Próximo',
    _InserirSenha: 'Inserir Senha',
    _VerificarSenhadeSaque: 'Verificar Senha de Saque',
    _DetalhesdeRetiradas: 'Detalhes de Retiradas',
    _Tipodetransação: 'Tipo de transação',
    _MétododeRetirada: 'Método de Retirada',
    _HoradeCriação: 'Hora de Criação',
    _Horadeexecução: 'Hora de execução',
    _NúmerodoPedido: 'Número do Pedido',
    _Vocêtambém: 'Você também precisa apostar efetivamente',
    _VocêtambémRight: 'para sacar dinheiro!',
    _Vezes: 'Vezes',
    _Apostaválidanecessária: 'Aposta válida necessária',
    _Adicionarponto: 'Adicionar ponto',
    _Completado: 'Completado',
    _fonte: 'fonte',
    _Saldo: 'Saldo',
    _Vocêprecisaapostar: 'Você precisa apostar',
    _sacardinheiro: 'sacar dinheiro',
    _Bonus: 'Bonus',
    _Estataxade: 'Esta taxa de manuseio≈R$ 0,00(chegada estimadaR$ 1.111,00)',
    _Tudo: 'Tudo',
    _Vejaasregrasparadetalhes: 'Veja as regras para detalhes',
    _Ganharjuros: 'Ganhar juros',
    _Confirmarretirada: 'Confirmar retirada',
    _TotaldeSaques: 'Total de Saques',
    _EmitindoparaPIX: 'Emitindo paraPIX',
    _AdicionarPIX: 'Adicionar PIX',
    _Confirmar: 'Confirmar',
    _Verifique:
      'Verifique cuidadosamente o nome e o número do cartão, caso contrário, não poderá ser creditado',
    _Contapararecebimento: 'Conta para recebimento',
    _Detalhesdatarefadeapostas: 'Detalhes da tarefa de apostas',
    _Tipodefonte: 'Tipo de fonte',
    _ObterAdicionarpontos: 'Obter/Adicionar pontos',
    _Exigirmultiplicadordeaposta: 'Exigir multiplicador de aposta',
    _Apostaválidanecessária: 'Aposta válida necessária',
    _Apostajáválida: 'Aposta já válida',
    _Vocêprecisaapostar: 'Você precisa apostar',
    _Statusdatarefa: 'Status da tarefa',
    _TempodeConclusão: 'Tempo de Conclusão',
    _Depósito: 'Depósito',
    _Adicionar: 'Adicionar',
    _EsperandoRetirada: 'Esperando Retirada',
    _RetiradaBemSucedida: 'Retirada Bem Sucedida',
    _RetiradaCancelada: 'Retirada Cancelada',
    _Aguardandoapostas: 'Aguardando apostas',
    _Têmemmão: 'Têm em mão',
    _Completado: 'Completado',
    _Abandonado: 'Abandonado',
    _AdicionarConta: 'Adicionar Conta',
    _Anual: 'Anual',
    _Lobby: 'Lobby'
  },
  subgame: {
    _Slots: 'Slots'
  },

  promote: {
    _MeuLink: 'Meu Link',
    _MododeAgente: 'Modo de Agente',
    _RededoAgente: 'Rede do Agente',
    _Nœud: 'Différence de niveau infini (Nœud de jour)',
    _Coletável: 'Coletável',
    _Subordinadosdiretos: 'Subordinados diretos',
    _CódigodeConvite: 'Código de Convite',
    _Receber: 'Receber',
    _Histórico: 'Histórico',
    _CliqueparaSalvar: 'Clique para Salvar',
    _Adicionarmembrosdiretos: 'Adicionar membros diretos',
    _PrimeirosDepósitos: 'Primeiros Depósitos',
    _Depósitos: 'Depósitos',
    _Depósito: 'Depósito',
    _Desempenho: 'Desempenho',
    _Comissão: 'Comissão',
    _ReportDataTitle: [
      'Dados de hoje do subordinado direto',
      'Dados de ontem do subordinado direto',
      'Dados desta semana do subordinado direto',
      'Dados da semana passada do subordinado direto',
      'Dados deste mês do subordinado direto',
      'Dados do mês passado do subordinado direto'
    ],
    _Datasummary: 'Resumo de dados',
    _MeuTime: 'Meu Time',
    _Desempenho: 'Desempenho',
    _Comissão: 'Comissão',
    _Membros: 'Membros',
    _MembrosDiretos: 'Membros Diretos',
    _OutrosMembros: 'Outros Membros',
    _RendimentoTotal: 'Rendimento Total',
    _Rendimento: 'Rendimento',
    _DDireto: 'D. Direto',
    _DdosOutros: 'D. dos Outros',
    _ComissõesTotais: 'Comissões Totais',
    _MemberID: 'Member ID',
    _ApostasVálidas: 'Apostas Válidas',
    _RecargaDireta: 'Recarga Direta',
    _Primeirarecargadireta: 'Primeira recarga direta',
    _OutroDepósito: 'Outro Depósito',
    _Outrasrecargasiniciais: 'Outras recargas iniciais',
    _DepósitoTotal: 'Depósito Total',
    _Totaldejogadoresfazendoprimeirosdepósitos:
      'Total de jogadores fazendo primeiros depósitos',
    _IDdeMembro: 'ID de Membro',
    _ComissãoDireta: 'Comissão Direta',
    _OutraComissão: 'Outra Comissão',
    _SubordinadosDele: 'Subordinados Dele',
    _Depósito: 'Depósito',
    _DatadeCadastro: 'Data de Cadastro',
    _ApostasVálidas: 'Apostas Válidas',
    _Datadelogin: 'Data de login',
    _Atual: 'Atual',
    _Estado: 'Estado',
    _Númerodeinscritos: 'Número de inscritos',
    _Apostasválidas: 'Apostas válidas',
    _Apostaválidadireta: 'Aposta válida direta',
    _VDdiretas: 'V/D diretas',
    _Depósitos: 'Depósitos',
    _PrimeirosDepósitos: 'Primeiros Depósitos',
    _Depósito: 'Depósito',
    _ApostasVálidas: 'Apostas Válidas',
    _Ontem: 'Ontem',
    _Hoje: 'Hoje',
    _EstáSemana: 'Está Semana',
    _ÚltimaSemana: 'Última Semana',
    _EsteMês: 'Este Mês',
    _MêsPassado: 'Mês Passado',
    _DataLiquidação: 'Data Liquidação',
    _customerservice: 'customer service',
    _Desempenhototal: 'Desempenho total',
    _RetornodeComiss: 'Retorno de Comissão',
    _escalonada: 'Comissão escalonada',
    _contribuicomissão: 'contribui comissão',
    _Contribuipara: 'Contribui para',
    _Dediferenciais: 'De diferenciais',
    _Donível: 'Do nível',
    _Semdenível: 'Sem diferença de nível',
    _Umexemplo: 'Um exemplo é o seguinte',
    _Comisde: 'Comissão de',
    _UmexemploSuponha:
      'Suponha que as apostas efetivas atuais de 0 a 10.000 receberão uma comissão de 100 (ou seja, 1%) para cada 10.000, e o apostas efetivas acima de 10.000 receberão uma comissão de 300 para cada 10.000. (ou seja, 3%), A foi o primeiro a descobrir oportunidades de negócios neste site e imediatamente desenvolveu B1, B2 e B3. B1 desenvolveu ainda mais C1 e C2. B2 desenvolveu sem subordinados, e a B3 desenvolveu o relativamente poderoso C3. No segundo dia, a aposta efetiva de B1 é 500, a aposta efetiva de B2 é 3.000, a aposta efetiva de B3 é 2.000, a aposta efetiva de C1 é 1.000, a aposta efetiva de C2 é 2.000 e a aposta efetiva de C3 é de até 20.000. ',
    _UmexemploEntseguinte:
      'Então o método de cálculo da renda entre eles é o seguinte',
    _Umexemplocontribui: 'contribuições diretas de',
    _semSubordinados: 'sem subordinados',
    _UmexemplodiretaMe: 'contribuição direta de',
    _UmexemploAlcontribui:
      ' Além das contribuições dos subordinados diretos B1, B2 e B3, a comissão de A também advém das contribuições dos demais subordinados C1, C2 e C3, conforme segue',
    _Comissdiretade: 'Comissão direta de',
    _Outrascomissesde: 'Outras comissões de',
    _dascontribui: 'das contribuições',
    _Comisstotalde: 'Comissão total de',
    _diretoOutro: 'direto + outro',
    _Resumo: 'Resumo',
    _Equipedireta: 'Equipe direta',
    _EquipediretaDes:
      'refere-se aos subordinados desenvolvidosdiretamente por A, ou seja, o primeiro nível de relacionamento com A,denominados coletivamente como equipe direta. ',
    _Outrasequipes: 'Outras equipes',
    _OutrasequipesDes:
      'Refere-se àquelas que são desenvolvidas por subordinados de A. Possuem relacionamento de segundo nível com A ou superior, ou seja, subordinados de subordinados , e os subordinados dos subordinados.. etc., coletivamente referidos como outras equipes; como esse modelo e agência pode desenvolver subordinados ilimitados, para conveniência da explicação, este artigo toma apenas a estrutura de 2 níveis como exemplo.',
    _Total: 'Total',
    _Vlidoouno: 'Válido ou não',
    _menregistro: 'Hora de registro',
    _DetalhesMe_me: 'Detalhes da expansão',
    _Lucroeperdademembro: 'Lucro e perda de membro',
    _Resgatardesconto: 'Resgatar desconto',
    _Detalhesdaaposta: 'Detalhes da aposta',
    _Subordinadosde: 'Subordinados de',
    _Plataformadejogo: 'Plataforma de jogo',
    _Nomedojogo: 'Nome do jogo',
    _ApostasVálidas: 'Apostas Válidas',
    _dosmembros: 'V/D dos membros',
    _Normal: 'Normal',
    _Lock: 'Lock',
    _Totaldeapostas: 'Total de apostas',
    _Comissrecebida: 'Comissão recebida',
    _TGServio: 'Telegram Serviço',
    _WSServio: 'WhatsApp Serviço',
    _deAtividade: 'Nível de Atividade',
    _Lembreteimportante: 'Lembrete importante',
    _Pontosdesorteatuais: 'Pontos de sorte atuais',
    _Vocaindaprecisaapostar: 'Você ainda precisa apostar',
    _paraobter: 'para obter',
    _Pontosdesorte: 'Pontos de sorte',
    _RODAR: 'RODAR',
    _RodaPrata: 'Roda de Prata',
    _RodaOuro: 'Roda de Ouro',
    _RodaDiamante: 'Roda de Diamante',
    _Perdasdeontem: 'Perdas de ontem',
    _Bnusdesuportehoje: 'Bônus de suporte de hoje',
    _Perdasdeontem2: 'Perdas da última semana',
    _Bnusdesuportehoje2: 'Subsídios desta semana',
    _Valordaperda: 'Valor da perda',
    _PrmiosExtra: 'Prêmios Extra',
    _recompensasMen_me: 'Não existem recompensas a serem recebidas no momento',
    _Primeirodepsito: 'Primeiro depósito',
    _Recompensa: 'Recompensa',
    _Dispositivoatual: 'Dispositivo atual',
    _Aplicativo: 'Aplicativo',
    _Versão: 'Versão',
    _Tipodeequipamento: 'Tipo de equipamento',
    _Sistema: 'Sistema',
    _ÁreaIP: 'Área IP',
    _Horáriodelogin: 'Horário de login',
    _Outrosdispositivos: 'Outros dispositivos'
  },

  mine: {
    _RecuperaroSaldo: 'Recuperar o Saldo',
    _Conta: 'Conta',
    _Apostas: 'Apostas',
    _Relatório: 'Relatório',
    _GestãoRetiradas: 'Gestão Retiradas',
    _Convidar: 'Agente',
    _Dados: 'Dados',
    _Segurança: 'Segurança',
    _Música: 'Música',
    _Idioma: 'Idioma',
    _FAQ: 'FAQ',
    _BônusdeSugestão: 'Bônus de Sugestão',
    _Façaloginnodispositivo: 'Faça login no dispositivo',
    _Sobre: 'Sobre',
    _Sair: 'Sair',
    _Suporte: 'Suporte',
    _Mensagens: 'Mensagens',
    _Dados: 'Dados',
    _Confirmarsaída: 'Confirmar saída',
    _Cancelar: 'Cancelar',
    _Desejaterminarsessãodaconta: 'Deseja terminar sessão da conta?',
    _Conta: 'Conta',
    _Lembrete: 'Lembrete',
    _Saque: 'Saque',
    _Depósito: 'Depósito',
    _Juros: 'Juros',
    _FundodePrevidência: 'Fundo de Previdência',
    _Apostaparapromoção: 'Aposta para promoção',
    _Restantes: 'Restantes',
    _Valorrestanteparaaposta: 'Valor restante para aposta',
    _RemainingDepositAmount: 'Valor restante para depósito',
    _DepositPromotion: 'Depósito para promoção',
    _SenhadeLogin: 'Senhas Login',
    _Cashback: 'Cashback',
    _unlogin_tip1: 'Por favor, primeiro ',
    _unlogin_tip2: 'Login ',
    _unlogin_tip3: 'Ou ',
    _unlogin_tip4: 'Registro',
    _function1: 'Juros',
    _function2: 'Meus Registros',
    _function3: 'Gestão de saques',
    _function4: 'VIP',
    _function5: 'Promoção',
    _function6: 'Dados',
    _function7: 'Segurança',
    _function8: 'Idioma',
    _function9: 'FAQ',
    _function10: 'Bônus de Sugestão',
    _function11: 'Faça login no dispositivo',
    _function12: 'Sair'
  },

  Login: {
    _Login: 'Login',
    _Registro: 'Registro',
    _Depósito: 'Depósito',
    _Saque: 'Saque',
    _Juros: 'Juros',
    _RegistrodeDepósito: 'Registro de Depósito',
    _Depósitoonline: 'Depósito on-line',
    _Expandir: 'Expandir',
    _Fechar: 'Fechar',
    _MínimoRechare: 'Mínimo ',
    _MáximoRechare: ', Máximo ',
    _Lembrete:
      "Lembrete：Clique em 'Comprar Saldo', selecione a quantia que você precisa, recarregue para aumentar seus pontos! !",
    _RecarregueAgora: 'Recarregue Agora',
    DepositeAgora: 'Deposite agora',
    _RegistrodeDepósito: 'Registro de Depósito',
    _Abraseuaplicativo:
      'Abra seu aplicativo de pagamento e digitalize ou copie e cole o código QR abaixo paraconcluir sua compra;',
    _Estecódigo:
      'Este código QR só pode ser pago uma vez. Se precisar pagar novamente, volte erecarregue;',
    _Apósopagamento:
      'Após o pagamento ser bem-sucedido, você pode retornar aolobby do jogo e aguardar a adição de pontos!',
    _DepósitoTotal: 'Depósito Total',
    _Pagamento: 'Pagamento',
    _Pendente: 'Pendente',
    _Jápago: 'Recarga Bem-sucedida',
    _PedidoExpirado: 'Pedido Expirado',
    _Tempoefetivo: 'Tempo efetivo',
    _CopiarcódigoQR: 'Copiar código QR',
    _EndereçodocódigoQR: 'Endereço do código QR',
    _Statusdopedido: 'Status do pedido',
    _RegistrosdeAuditoria: 'Registros de Auditoria',
    _HoradeCriação: 'Hora de Criação',
    _NúmerodoPedido: 'Número do Pedido',
    _Númerodopedidodocomerciante: 'Número do pedido do comerciante',
    _Lembre: 'Lembrar da senha da conta',
    _Suporte: 'Suporte Número do Celular/Conta Login',
    _Suporteaocliente: 'Suporte ao cliente',
    _JogarGrátis: 'Jogar Demo',
    _EsqueceuaSenha: 'Esqueceu a Senha',
    _dengLuPa: 'Por favor, insira Número do Celular/Conta',
    _Senha: 'Senha',
    _SuporteContaRegistro: 'Suporta apenas ContaRegistro',
    _Registrodocódigodeverificação: 'Registro do código de verificação',
    _Cadastrodesenha: 'Cadastro de senha',
    _accAcrt:
      'A moeda determina os jogos de terceiros e os métodos de pagamento e não pode ser modificada.',
    _Tenhomaisde: 'Tenho +18 anos, li e concordo com os Termos de Uso',
    _Tenhomaisde2: 'Li e concordo com o',
    _AcordodeUsuário: 'Acordo de Usuário',
    _AcordodeUsuário2: 'Acordo de Usuário',
    _Confirme: 'Confirme a senha novamente, o mesmo que a senha!',
    _DigiteoNúmerodoCelular: 'Digite o Celular',
    _VerificaçãodeID: 'Verificação de ID',
    _RedefiniçãodeSenha: 'Redefinição de Senha',
    _Terminar: 'Terminar',
    _ErroNo: 'Erro no formato da conta,4-16 caracteres, suporta inglês/números',
    _caracteresMens:
      '6-16 caracteres, incluindo pelo menos duas letras/números/símbolos',
    _vazioestar: 'Número do CelularCampo não pode estar vazio',
    _Seguintes: 'Seguintes',
    _realName:
      'Preencha o nome verdadeiro e torne -o conveniente para a retirada posterior!',
    newText1: 'Faça login com WhatsApp para vídeo chamadas com mulheres reais',
    newText2: 'Aproveite conteúdos mais excitantes!',
    newText3: 'Por favor, insira o número de telefone do WhatsApp',
    newText4: 'Insira o código no seu telefone',
    newText5: 'Associando conta do WhatsApp',
    newText6: 'Copiar para o WhatsApp',
    newText7: 'O código de pareamento foi copiado, por favor cole no WhatsApp',
    newText8: 'Por favor, preste atenção ao pop-up do WhatsApp a seguir.',
    newText9: 'Código de verificação:',
    newText10: 'TENTAR NOVAMENTE',
    newText11: 'Digite seu número de telefone',
    newText12: 'Por favor, insira um número de telefone válido',
    newText13: 'Configurar senha',
    newText14: 'Digite a senha',
    newText15: 'A senha não pode ser inferior a seis dígitos.',
    newText16: 'A senha é muito simples.',
    newText17: 'MÁXIMO DE TENTATIVAS ALCANÇADO',
    newText18: 'A tentativa máxima foi alcançada. Tente novamente mais tarde.'
  },

  components: {
    _copySuccess: 'Copiado com sucesso',
    _Registradocomsucesso: 'Registrado com sucesso',
    _Vamosjogaragora: 'Vamos jogar agora',
    _CheckInDi: 'Check In Diá',
    _Resgatado: 'Resgatado',
    _Depósitoobrigatrio: 'Depósito obrigatório',
    _Apostaobrigatri: 'Aposta obrigatória',
    _Entrar: 'Entrar',
    _Check_insconsecutivos: 'Check-ins consecutivos',
    _Falhanocheckin: 'Falha no check-in',
    _Irparadepsito: 'Ir para depósito',
    _Topo: 'Topo',
    _TOPO_1: 'TOPO',
    _Encontre_nos: 'Encontre-nos',
    _LoginRpido: 'Login Rápido',
    _GoogleLogin: 'Google Login',
    _CanalOficial: 'Canal Oficial',
    _Telegramoficial: 'Telegram oficial',
    _Instagramoficial: 'Instagram oficial',
    _Siteoficial: 'Site oficial',
    _DatadeInício: 'Data de Início',
    _DatadeFim: 'Data de Fim',
    _Confimar: 'Confimar',
    _Preencha: 'Preencha corretamente as informações: O CPF da conta que',
    _normalmente: 'requisitou este pagamento para ser creditada normalmente',
    _Wrongamount: 'Quantidade errada',
    _Introduzaoseunomereal: 'Introduza o seu nome real',
    _Strength: 'Força',
    _IntroduzadoCPF: 'Introduza o número de 11 dígitos do CPF',
    _paymentpage: 'Por favor aguarde, vá para a página de pagamento!',
    _Deptodo: 'Método de Depósito',
    _Canalderecarga: 'Canal de recarga',
    _Bnusdeprimeirodepsito: 'Bónus de primeiro depósito',
    _hojeNovamente: 'Não mostrar novamente hoje',
    _Ocultarpermanenfemente: 'Ocultar permanenfemente',
    _Prosseguir: 'Prosseguir',
    _Total_deapostas: 'Total de apostas durante o evento',
    _ValorSorteUtilizado: 'Valor de sorte utilizado',
    _Valordasorteexpirado: 'Valor da sorte expirado',
    _ValorSortedisponvel: 'Valor de sorte disponível',
    _Containsira: 'Digite o Conta',
    _novamentefavor: 'Por favor, confirme sua senha novamente',
    _Brasil55: 'Brasil（+55）',
    _Registrar: 'Registrar',
    _Registrovinculativo: 'Registro vinculativo',
    _PorfavorinsiraConta: 'Por favor, insira Conta',
    _mboloscaracteres6_16:
      '6-16 caracteres, incluindo pelo menos duas /n letras/números/símbolos',
    _apenasM_Registro: 'Suporta apenas Conta Registro',
    _CelularRegistroMe: 'Suporta apenas Número do Celular Registro',
    _Verifiqueacordo: 'Verifique primeiro o acordo de utilizador',
    _vinculadoCPF: 'CPF inválido ou vinculado',
    _digitenovamente: 'A conta não suporta 6-12 dígitos puros, digite novamente',
    _suporta_dr_55: 'O código de área +55 suporta 10-11 números de celular, digite novamente',
    _Esteonmerodo: 'Este é o número do',
    _Estaaconta: 'Esta é a conta',
    _SuporteapenasContaLogin: 'Suporte apenas Conta Login',
    _SuporteapenasdoCelularLogin: 'Suporte apenas Número do Celular Login',
    _DigiteoConta: 'Digite o Conta',
    _Digite_Celular_e: 'Digite o Número do Celular/Conta',
    _celularSuporta: 'suporta 10-11 números de celular',
    _inglMbolos_men: '6-16 dígitos, inglês/números/símbolos',
    _novamenteConfirme: 'Confirme a senha novamente, o mesmo que a senha!',
    _recebera: 'Você receberá',
    _evento: 'Bônus do evento',
    _coletar: '(Lembre-se de coletar)',
    _Deppsito: 'Oferta de Depósito',
    _Participacao: 'Participação automática nas seguintes atividades'
  },
  RecuperaroSaldo: {
    _RecuperaroSaldo: 'Recuperar o Saldo',
    _Saldoatual: 'Saldo atual',
    _Umcliquepararecuperar: 'Um clique para recuperar',
    _yaTeng:
      'Você só pode recuperar o múltiplo inteiro do equilíbrio (ou seja, semponto decimal)',
    _Tudos: 'Tudos',
    _Pesquisadeplataforma: 'Pesquisa de plataforma'
  },

  report: {
    _Conta: 'Conta',
    _Apostas: 'Apostas',
    _Relatório: 'Relatório',
    _Valorcumulativodaaposta: 'Valor cumulativo da aposta',
    _TotaldeApostasVálidas: 'Total de Apostas Válidas',
    _TotaldeV: 'Total de V/D',
    _DepósitoTotal: 'Depósito Total',
    _TotaldeSaques: 'Total de Saques',
    _AcumuladoTotal: 'Acumulado Total',
    _Saldo: 'Saldo',
    _ApostasVálidas: 'Apostas Válidas',
    _GanhosePerdas: 'Ganhos e Perdas',
    _NúmerodaNota: 'Número da Nota'
  },

  security: {
    _SenhadeSaque: 'Senha de Saque',
    _Paraase:
      'Para a segurança dos seus fundos, você precisa primeiro definir uma senha de saque!',
    _Definasuasenhadesaque: 'Defina sua senha de saque',
    _NovaSenhadeSaque: 'Nova Senha de Saque',
    _Nãomesmosounúmeroscontínuos: 'Não pode ser 6 mesmos ou números contínuos',
    _Atenção:
      'Atenção: A senha de saque protege seus fundos e é extremamente importante. Mantenha-a em segredo para evitar qualquer perda financeira.',
    _Confirmar: 'Confirmar',
    _Senhaincorreta: 'Senha incorreta, digite novamente!',
    _Confirmenova: 'Confirme a nova senha de saque',
    _AlterarSenhadeSaque: 'Alterar Senha de Saque'
  },
  _homeTile_tab: {
    _meCmeTen: 'A conta PIX não pode ficar vazia',
    _primeiroprecisa: 'Você precisa estabelecer uma senha de retirada primeiro',
    _VerifiqueAntiga: 'Verifique a senha de login antiga',
    _Convideumapessoa: 'Recomende amigos para abrir o Baú dos Prêmios',
    _CupomRecompensas: 'Cupom Recompensas',
    _Centrodemensagens: 'Centro de mensagens',
    _Girodasorte: 'Giro da sorte',
    _DetalhesdoDepsito: 'Detalhes do Depósito',
    _campodeNomereal: 'O campo de nome real não pode ficar vazio',
    _Descride: 'Descrição de',
    _Explicao: 'Explicação',
    _Resumodasregras: 'Resumo das regras',
    _importaquando:
      'Não importa quando você ingressa, de quem você é subordinado, não importa em que nível você está, sua renda nunca será afetada e você não sofre mais as perdas dos subordinados dos outros., o desenvolvimento não é restrito. Este é um modelo de agência absolutamente justo e imparcial, e ninguém estará sempre por baixo só porque entrou tarde.',
    _tenhaEmbora:
      'Embora B3 tenha aderido relativamente tarde e seja subordinado de A, seu subordinado C3 é muito poderoso e tem um desempenho direto de 20.000, permitindo que B3 diretamente desfrutar de comissões mais elevadas.A proporção é de 3%. ',
    _preguiBeneficiar:
      'B2 pode ser preguiçoso e não se beneficiará se não desenvolver seus subordinados. ',
    _menTenMensg:
      'B1 tem subordinados C1 e C2. Como o desempenho direto é 3.000, o índice de desconto correspondente é de 1%.',
    _contribuiComiss: 'A A comissão de contribuição é 0.',
    _diretoDesempenho:
      'O desempenho direto de A é 5.500 e o outro desempenho é 20.000 (devido ao poder de C3). O desempenho total é 28.500 e a comissão correspondente a taxa é de 3%. Como B1 tem um desempenho total de 3.000 e desfruta de um desconto de apenas 1%, enquanto A tem um desempenho total de 28.500 e desfruta de uma taxa de desconto de 3%, então haverá uma diferença de desconto entre A e B1. A diferença é: 3% -1% =2%, essa diferença é a parte contribuída por C1 e C2 para A, então C1 e C2 contribuem para A: (1000+2000)* 2%=60, não há diferença extrema entre A e B3, então C3',
    _Emandamento: 'Em andamento',
    _ltimosDias2: 'Últimos 2 meses',
    _ltimosDias3: 'Últimos 3 meses',
    _ltimosDias7: 'Últimos 7 Dias',
    _ltimosDias15: 'Últimos 15 Dias',
    _ltimosDias30: 'Últimos 30 Dias',
    _Quasedias60: 'Quase 60 dias',
    _TodososStatus: 'Todos os Status',
    _NoLiquidado: 'Não Liquidado',
    _Liquidado: 'Liquidado',
    _Pedidocancelado: 'Pedido cancelado',
    _TodososTipos: 'Todos os Tipos',
    _TrocadeFundos: 'Troca de Fundos',
    _RecargadeMembro: 'Recarga de Membro',
    _SaquedeMembro: 'Saque de Membro',
    _LiquidaodoComerciante: 'Liquidação do Comerciante',
    _CorreodeFundo: 'Correção de Fundo',
    _TaxadeRebate: 'Taxa de Rebate',
    _Bonus: 'Bônus',
    _Distribudo: 'Distribuído'
  },

  noticeInfo: {
    _menCmensEscaneie:
      'Escaneie o código QR ou abra o link de convite em um navegador. Baixe o jogo e inscreva-se, depois use seu código QR exclusivo ou link de convite para convidar outras pessoas.',
    _menCmensClique:
      "Clique em 'Promoção' no lobby para entrar na página da promoção. Seu código QR exclusivo e o link promocional podem ser encontrados na parte inferior. Salve a imagem e compartilhe.",
    _menCmensrendimento:
      'O rendimento refere-se às apostas válidas do jogador no jogo. Por exemplo, se você promoveu um jogador que fez 1.000 apostas válidas, isso equivale a 1.000 contribuições de desempenho.',
    _menCmenscliqueverificar:
      "Vá em 'Promoção' e clique em 'Desempenho' para verificar seu nível de desempenho. Você também pode clicar em 'Minha Comissão' para verificar suas comissões cobráveis ​​e histórico de liquidação.\r\n",
    _menCmensVoce:
      "Você pode sacar dinheiro clicando em 'Retirar dinheiro' inserindo os dados corretos do cartão bancário.",
    _menCmensApos:
      'Após recarregar, os jogadores devem fazer apostas válidas no jogo. A transação de retirada só será concluída após a análise dessa solicitação.',
    _menCmensEscaneie_title: 'Como se tornar um agente?',
    _menCmensClique_title: 'Onde posso compartilhar o código de convite?',
    _menCmensrendimento_title: 'Como é calculado o desempenho?',
    _menCmenscliqueverificar_title:
      'Onde posso verificar meu nível de desempenho e comissão?',
    _menCmensVoce_title: 'Como sacar dinheiro?',
    _menCmensApos_title:
      'Qual é o requisito para recarregar e retirar dinheiro?',
    _Outrasperguntas: 'Outras perguntas',
    _PerguntasSobrecoleao: 'Perguntas sobre coleção',
    _Perguntasderecarga: 'Perguntas de recarga',
    _Perguntasdojogo: 'Perguntas do jogo',
    _SistemadeMsica: 'Sistema de Música',
    _MinhasMsicas: 'Minhas Músicas',
    _Ciclo: 'Ciclo',
    _Baixado: 'Baixado'
  },

  common: {
    // ......
    title1: 'Jogo especiais',
    mineText1: 'Faça login para ganhar bônus',
    mineText2: 'Informações de exibição padrão',
    mineText3: 'Check In Diário',
    mineText4: 'Faça login todos os dias e aproveite inúmeros presentes!',
    mineText5: 'Mais eventos',
    mineText6:
      'Por favor, Baixe e faça login no APP、Faça login na página da web para celular colete-o',
    mineText7: 'Função rápida'
  },
  index: {
    // ......
  }
};
